import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_ORIGIN = 'https://wpaauae.com';

/**
 * Injects/updates <link rel="canonical"> and <meta property="og:url">
 * in document.head on every route change. Consolidates SEO ranking signals
 * onto the wpaauae.com version even if the www subdomain is hit.
 */
const CanonicalTag = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const clean = pathname.replace(/\/+$/, '') || '/';
    const url = `${SITE_ORIGIN}${clean}`;

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', url);
  }, [pathname]);

  return null;
};

export default CanonicalTag;
